// extracted by mini-css-extract-plugin
export default {"gallery":"c-j_gX","gallery__header":"c-j_gY","gallery__thumbs":"c-j_gZ"};